module.exports = __webpack_public_path__ + "static/img/kosha-risk assessment-pt.95d1c25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kosha-risk assessment-pt.jpg
// module id = jBiM
// module chunks = 0